import React from "react";
import Hero from "@/components/Hero";
import ServicesBento, { CitiesBand } from "@/components/ServicesBento";
import EditorialMarquee from "@/components/EditorialMarquee";
import Manifesto from "@/components/Manifesto";
import QuoteForm from "@/components/QuoteForm";
import SEO, { buildLocalBusinessJsonLd } from "@/components/SEO";
import { BUSINESS } from "@/data/config";
import { motion } from "framer-motion";

export default function Home() {
  return (
    <>
      <SEO
        title="Spokane Gutters, Guards, and Roofing | Seamless, Same Day"
        description="Family owned gutter installation, repair, cleaning, guards, and roofing across Spokane, Spokane Valley, Liberty Lake, Mead, Cheney, and Nine Mile Falls."
        path="/"
        jsonLd={buildLocalBusinessJsonLd()}
      />
      <Hero />

      <EditorialMarquee />

      <ServicesBento />

      {/* Stats strip */}
      <section className="border-y border-white/10 bg-ink-950" data-testid="stats-strip">
        <div className="max-w-[1440px] mx-auto px-5 md:px-10 grid grid-cols-2 md:grid-cols-4">
          {[
            { n: "1,400+", l: "Homes served" },
            { n: "11 yrs", l: "In business" },
            { n: "4.9", l: "Average review" },
            { n: "1 day", l: "Most quote turnaround" },
          ].map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className={`p-8 md:p-12 border-white/10 ${i > 0 ? "md:border-l" : ""} ${i % 2 !== 0 ? "border-l" : ""} ${i < 2 ? "md:border-b-0 border-b" : ""}`}
            >
              <div className="font-display text-4xl md:text-6xl text-copper-500 leading-none tracking-tightest mb-3">
                {s.n}
              </div>
              <div className="text-sm md:text-base text-bone-300 font-heading">{s.l}</div>
            </motion.div>
          ))}
        </div>
      </section>

      <CitiesBand />

      <Manifesto />

      {/* Quote form section */}
      <section id="quote" data-testid="home-quote-section" className="relative py-16 md:py-32 bg-ink-900 border-t border-white/10">
        <div className="max-w-[1440px] mx-auto px-5 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <p className="overline mb-4">Start the job</p>
            <h2 className="font-display text-4xl md:text-6xl leading-[0.95] tracking-tightest text-bone-50">
              Tell us about the roof. We handle the rest.
            </h2>
            <p className="mt-6 text-bone-300 text-lg leading-relaxed max-w-md">
              A person answers the form. A crew shows up on time. A written quote lands in your inbox before the end of the week.
            </p>
          </div>
          <div className="lg:col-span-7">
            <QuoteForm />
          </div>
        </div>
      </section>
    </>
  );
}
